export default "__VITE_ASSET__DouPW_mo__"